var map = {
	"./black/baojingjiechu2.png": "ntpD",
	"./blue/baojingjiechu2.png": "pZe0",
	"./white/baojingjiechu2.png": "eLg8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pakG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/baojingjiechu2\.png$
// module id = pakG
// module chunks = 24